import VideoForm from './components/embeds/VideoForm.vue'
import QuestionForm from './components/slides/questions/QuestionForm.vue'
import SparkQuestionForm from './components/slides/blocks/sparks/SparkQuestionForm.vue'
import LayoutForm from './components/slides/layouts/LayoutForm.vue'
import PrepForm from './components/prep/PrepForm.vue'
import VariantPicker from './components/slides/questions/VariantPicker.vue'
import SparkForm from './components/slides/questions/SparkForm.vue'
import StudentViewPreview from './components/slides/StudentViewPreview.vue'
import LessonSettingsForm from './components/settings/LessonSettingsForm.vue'

export const SIDE_PANEL_COMPONENTS = {
  VideoForm,
  QuestionForm,
  SparkQuestionForm,
  LayoutForm,
  PrepForm,
  VariantPicker,
  SparkForm,
  StudentViewPreview,
  LessonSettingsForm
}
